import { render, staticRenderFns } from "./UHooSetting.vue?vue&type=template&id=676e0baa&scoped=true"
import script from "./UHooSetting.vue?vue&type=script&lang=js"
export * from "./UHooSetting.vue?vue&type=script&lang=js"
import style0 from "./UHooSetting.vue?vue&type=style&index=0&id=676e0baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e0baa",
  null
  
)

export default component.exports